import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import loginImg from '../Img/manuscript_img.png';
import '../CSS/Global.css';


const Login = () => {
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showResendButton, setShowResendButton] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [otpworld1, setOtpworld1] = useState(false);
  const [otpworld2, setOtpworld2] = useState(false);
  const [confirmObj, setConfirmObj] = useState("");
  const navigate = useNavigate();
  const [load, setLoad] = useState(true);
  const [data, setData] = useState({
    email: '',
    password: '',
  })
  const isLoggedIn = Boolean(localStorage.getItem("isLoggedIn"));
  const url = process.env.REACT_APP_LINK
  const handleChange = (e) => {
    const { name, value } = e.target
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(false);

    try {
      const response = await fetch(`${url}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          email: phone,
          password: password
        })
      })
      const res = await response.json();
      if (response.ok) {
        navigate("/all-users")
        localStorage.setItem("isLoggedIn", JSON.stringify(res.user))
        localStorage.setItem("token", (res.token))
      }
    } catch (error) {

    }


    setLoad(true);
  };




  return (
    <>

      {/* <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}> */}
      <div className="login-bg">
        <div className="login-img">
          <img src={loginImg} alt="" />
        </div>
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="phone"
              placeholder="Email"
              value={phone}
              onChange={handlePhoneChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={handlePasswordChange}
            />
            {/* <p className="register">
              By continuing, I agree to the <Link to='https://100billiontech.com/terms-and-conditions'>Terms of use</Link> & <Link to='https://100billiontech.com/privacy-policy'>Privacy Policy</Link>
            </p> */}
            {
              load ? <button type="submit">Continue</button> :
                <button type="button" disabled>Loading...</button>
            }

          </form>
          {/* <p className="divider">Or sign in with</p>
                    <div className="google">
                        Sign in with Google
                    </div> */}
          {/* <p className="register">
            Don't have an account? <Link to='/register'>Register now</Link>
          </p> */}
          <Link to='/reset' style={{ textDecoration: "none" }}><p className="reset-btn">Having trouble in sign in?</p></Link>
        </div>
      </div>
      {/* </div> */}
    </>
  );
};

export default Login;
